import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const NotificationError = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 18 18">
    <path
      d="M9 17.25C13.5563 17.25 17.25 13.5563 17.25 9C17.25 4.44365 13.5563 0.75 9 0.75C4.44365 0.75 0.75 4.44365 0.75 9C0.75 13.5563 4.44365 17.25 9 17.25Z"
      fill="#A72535"
    />
    <path
      d="M8.02905 12.1636C8.02905 12.7282 8.48267 13.1515 9.08753 13.1515C9.69238 13.1515 10.146 12.7282 10.146 12.1636C10.146 11.5991 9.69238 11.1757 9.08753 11.1757C8.48267 11.1051 8.02905 11.5991 8.02905 12.1636Z"
      fill="#FEF6F6"
    />
    <path
      d="M8.10453 9.55262L7.57527 6.02436C7.42408 5.17757 8.18013 4.40137 9.08735 4.40137C9.99464 4.40137 10.7507 5.17757 10.5994 6.02436L10.0702 9.55262C9.99459 9.976 9.61657 10.3288 9.0873 10.3288C8.55815 10.3994 8.18013 10.0466 8.10453 9.55262Z"
      fill="#FEF6F6"
    />
  </SvgIcon>
));

export default React.memo(NotificationError);
